import React , { FC, useEffect, useState } from "react";

import { GetPrevSimulData } from "../services/PrevSimulService"
import { UseConfigContext } from "../Context/ConfigContext";
import { ClDonneesPrevSimulation } from "../Model/PrevSimulData";
import dayjs, { Dayjs } from "dayjs";
import { UseSalarySimContext } from "../Context/SalarySimContext";
import { MapServiceInputPostDataToInputData } from "../services/MapService";

import { DataGridPro , GridColDef } from '@mui/x-data-grid-pro';
import { GridPreviousSimulationDataModel } from "../Model/GridPreviousSimulationDataModel";
import { UseTranslationContext } from "../Context/TranslationContext";
import LocalizedDatePicker from "./LocalizedDatePicker";
import { nlNL } from '@mui/x-data-grid';
import { frFR } from '@mui/x-data-grid';
import { enUS } from '@mui/x-data-grid';

import { UseToastContext, toastType } from "../Context/ToastContext";
import { InitPresta } from "../services/PrestaService";
import { useForm, useFormState } from "react-hook-form";
import { FormSuite } from "../FormModel/FormPreviousSimulationImport";
import { vestResolver } from "@hookform/resolvers/vest";
  
const PreviousSimulationComponent: FC = () => {
    const{currentLanguage, getKeyFromKeyId} = UseTranslationContext();
    const [prevData, setprevData] = useState(new Array<ClDonneesPrevSimulation>());
    
    //isconfigloaded = reaction lorsque composant chargé
    const { isConfigLoaded, getServiceUrl } = UseConfigContext();
    const [previousSimPopupDisplay, setpreviousSimPopupDisplay] = useState(false);
    const [dateBeginSearch, setdateBeginSearch] = useState<Dayjs>(dayjs().subtract(1,'week').utc(true));
    const [dateEndSearch, setdateEndSearch] = useState<Dayjs>(dayjs().utc(true));

    //const [selectedSimul, setselectedSimul] = useState<ClDonneesPrevSimulation|undefined>(undefined);
    const {updateSalarySimData, SetIdAgent, salarySimAdvancedFormData } = UseSalarySimContext();
    const [simulLoadingInProgress, setsimulLoadingInProgress] = useState(false);
    
    const [gridData,setGridData] = useState(new Array<GridPreviousSimulationDataModel>());
    const [locale, setLocale] = useState(frFR.components.MuiDataGrid.defaultProps.localeText);
    const { popToast } = UseToastContext();

    const {register, handleSubmit, setValue, trigger, formState: {errors, isValid}, control} = useForm({
        resolver:vestResolver(FormSuite),
        mode:'onChange',
        reValidateMode: 'onChange',
        context: undefined,
        criteriaMode: "firstError",
        shouldFocusError: false,
        shouldUnregister: false,
        delayError: undefined,
    });

    const salaryFormater = (cell : any) => {
        return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(cell);
    }

    const columns: GridColDef[] = [
        { field: 'NomSimul', headerName: getKeyFromKeyId("NOM"), width: 250 },
        { field: 'DtSimul', headerName: getKeyFromKeyId("CREATION_DATE"), width: 250, type: 'Date' },
        { field: 'BrutSimul', 
          headerName: getKeyFromKeyId("BRUT"), 
          width: 200, 
          type: 'number',
          renderCell:(params) => { 
            return salaryFormater(params.value);
          } 
        },
        { field: 'NetSimul', 
          headerName: getKeyFromKeyId("NET"), 
          width: 200, 
          type: 'number' ,
          renderCell:(params) => { 
            return salaryFormater(params.value);
          } 
        }
    ];
    
    const handleClickOpen = async () => {
        setpreviousSimPopupDisplay(true);
        
    };

    const handleClose = () => {
        setpreviousSimPopupDisplay(false);
    };

    function handleClickLoadSimul (idToLoad : GridPreviousSimulationDataModel) {
        var selectedSimulationToLoad = MapServiceInputPostDataToInputData(idToLoad.SauvegardeData);
        if(updateSalarySimData != null){
            updateSalarySimData(selectedSimulationToLoad,0,false);
            handleClose();
        }
    };

    //fonction pour aller chercher les données des simulations précédentes et les set dans prevData
    const TryLoadFromOldSimul = async (dateBegin:Dayjs, dateFin:Dayjs) => {
        
        setsimulLoadingInProgress(true);
        var prevSimulData = await GetPrevSimulData(getServiceUrl(), salarySimAdvancedFormData.agent,dateBegin,dateFin);
        var gridTemplate = new Array<GridPreviousSimulationDataModel>();

        if (prevSimulData != null){
            if(typeof prevSimulData == 'string')
            {
                popToast(toastType.Error, getKeyFromKeyId(prevSimulData));
            }
            else{
                prevSimulData.forEach(element => {
                    gridTemplate.push({
                        id : element.IdTechnique,
                        NomSimul : element.Sauvegarde.nom,
                        DtSimul : dayjs(element.DtCreation).format('DD/MM/YYYY HH:mm'),
                        BrutSimul : element.Sauvegarde.brut,
                        NetSimul : element.Sauvegarde.net,
                        SauvegardeData : element.Sauvegarde
                    });
                });
        
                setGridData(gridTemplate);
                setprevData(prevSimulData);
                
            }
        }
        setsimulLoadingInProgress(false);
        
    }

    //Pour charger le contenu du tableau lors du click sur le bouton => declenché par le changement d'état de "previousSimPopupDisplay"
    useEffect(() => {
        if (isConfigLoaded && previousSimPopupDisplay){
            //date de debut = date du jour - 7 jours /// date de fin = date du jour 

            var dateStartTemp = dayjs().subtract(1,'week').utc(true);
            var dateEndTemp = dayjs().utc(true);

            setdateBeginSearch(dateStartTemp);
            setdateEndSearch(dateEndTemp);

            TryLoadFromOldSimul(dateStartTemp,dateEndTemp);
        }
    }, [previousSimPopupDisplay]);

    useEffect(() => {
        if(currentLanguage != locale)
        {
          if(currentLanguage == 'fr')
          {
            setLocale(frFR.components.MuiDataGrid.defaultProps.localeText);
          }
          else if(currentLanguage == 'nl')
          {
            setLocale(nlNL.components.MuiDataGrid.defaultProps.localeText);
          }
          else
          {
            setLocale(enUS.components.MuiDataGrid.defaultProps.localeText);
          }
        }
    },[currentLanguage])

    useEffect(() => {
        if(isConfigLoaded)
        {
            var identifyServicePromise = InitPresta(getServiceUrl());
            identifyServicePromise.then((Result) => {
                if (typeof Result == "string" || Result.IsAuth == false)
                {
                    if(SetIdAgent != null){
                        SetIdAgent("SALARYSIM");
                    }
                }
                else // class AuthGS
                {
                    SetIdAgent(Result.UserName);
                }
            })
        }

    }, [isConfigLoaded])


    const RefreshSimulationData=(data:any) => {
        TryLoadFromOldSimul(data?.date_start, data?.date_end);
    }

    const onFormError=(data:any, e:any) => {

    }

    const RefreshSimulationDate =(myDate:Dayjs, isBeginDate:boolean) => {
        if(myDate != null && myDate != undefined)
        {
            if(isBeginDate)
            {
                setValue('date_start', myDate.utc(true), { shouldValidate: true, shouldDirty: true});
                trigger(["date_end"]);
            }
            else
            {
                setValue('date_end', myDate.utc(true), { shouldValidate: true, shouldDirty: true});
            }
        }
    }


    return (
        <> 
            <div>
                <button type="button" onClick={handleClickOpen} className="button-gost w-inline-block exportButton">
                    <p className="button-text-gost">{getKeyFromKeyId("LOAD_PREV_SIMULATION")}</p>
                </button>
            </div>
            
            {previousSimPopupDisplay &&
                <>

                    <div className="pop-up">
                        <div className="box-pop-up">
                            <button type="button" aria-label="close" onClick={handleClose} className="ic-close w-button"></button>
                            <h3 className="head-pop-up"> {getKeyFromKeyId("LOAD_PREV_SIMULATION")} </h3>

                            <form id="formStep1" onSubmit={handleSubmit((d) => RefreshSimulationData(d), (data, e) => onFormError(data,e))} name="form data import" data-name="data-import" method="post" aria-label={"data import"}>
                            <div className="group-field-load">
                                <div className="group-field">
                                    <div className="group-label">
                                    <label aria-hidden="true" htmlFor="date-de-debut" className="field-label-icon">
                                        {`${getKeyFromKeyId("DATE_FIRST_SEARCH")} `}</label>
                                    </div>
                                    <div className="text-field-icon">
                                        <LocalizedDatePicker startDate={dateBeginSearch} updateDate={ (myDate:Dayjs)=>RefreshSimulationDate(myDate, true)} />
                                    </div>
                                    <div>
                                        {errors?.date_start && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.date_start.message as any)}</p>} 
                                    </div>
                                </div>

                                <div className="group-field">
                                    <div className="group-label">
                                    <label aria-hidden="true" htmlFor="date-de-debut" className="field-label-icon">
                                        {`${getKeyFromKeyId("DATE_LAST_SEARCH")} `}</label>
                                    </div>
                                    <div className="text-field-icon">
                                        <LocalizedDatePicker startDate={dateEndSearch} updateDate={ (myDate:Dayjs)=>RefreshSimulationDate(myDate, false)} />
                                    </div>
                                    <div>
                                        {errors?.date_end && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.date_end.message as any)}</p>} 
                                    </div>
                                </div>

                                <button type="submit" className="button loadButton">
                                    {getKeyFromKeyId("PRESTA_LOAD")}
                                </button>
                            </div>



                            </form>

                            <div className="form-block w-form">
                                
                                <div className="main-pop-up">

                                    {/* Grille affichage */}
                                    <div style={{ height: 380, width: '100%' }}>
                                        
                                        <DataGridPro 
                                        sx={{
                                            fontSize : '1.5rem'
                                        }}
                                        rows={gridData} 
                                        columns={columns} 
                                        
                                        initialState={{
                                            pagination : {
                                                paginationModel : {
                                                    pageSize: 5
                                                }
                                            },
                                            sorting:{
                                                sortModel: [{ field: 'DtSimul', sort: 'desc' }],
                                            }
                                        }}
                                        loading={simulLoadingInProgress}

                                        pagination
                                        pageSizeOptions={[5]}
                                        localeText= {locale}
                                        
                                        onRowClick={(params) => {
                                            handleClickLoadSimul(params.row)
                                        }}

                                        
                                        
                                        // slots={{ 
                                        //     toolbar: GridToolbar 
                                        // }} 

                                        />
                                    </div>

                                </div>
                            </div>
                            
                        </div>

                    </div> 
            

                </>
            }
           
        </>
    );
    
    
    
    
}
export default PreviousSimulationComponent;